module.exports = __webpack_public_path__ + "static/media/04.1761d3fd.mp3";